import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-analytics-invite-sent-reviews",
  templateUrl: "./analytics-invite-sent-reviews.component.html",
  styleUrls: ["./analytics-invite-sent-reviews.component.scss"],
})
export class AnalyticsInviteSentReviewsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
